<template lang="html">
  <div class="wrapper">
    <transition name="slide-fade">
      <div v-if="showReport" class="new-report">
        <h2>⚠️ Unread progress report</h2>
        <p>Communications recieved during previous hibernation cycle.</p>
        <router-link to="/reports">View report</router-link>
      </div>
    </transition>
    <div :class="logsDisabled ? 'disabled' : ''">
      <h2>Enter new log</h2>
      <label>Equipment and personnel status: {{ remainingChars }} {{ remainingChars === 1 ? 'char' : 'chars'}} remaining</label>
      <textarea id="textarea" :maxlength="maxLogLength" v-model="currentLogText"></textarea>
      <div class="below-textarea">
        <p :class="['latest-card', 'card-container', isAce ? 'ace' : '']">{{ latestCardFormatted }}</p>
        <p class="hidden-prompt">{{ getSleepPrompt(-1) }} {{ getDreamPrompt(-1) }}</p>
        <button :class="finalCommit && !postGame ? 'button-final' : ''" @click="commitLogHandler" :disabled="logsDisabled || emptyLog || postGame">{{ buttonText }}</button>
      </div>
    </div>
    <hr>
    <h2>Previous logs</h2>
    <div v-for="(record, i) in previousLogs.slice().reverse()" :key="i">
      <TextRecord v-if="record.shouldDisplay" :record="record" :even="i % 2 === 0" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

import TextRecord from '@/components/TextRecord';

export default {
  name: 'Logs',
  components: {
    TextRecord,
  },
  data() {
    return {
      currentLogText: '',
      showReport: false,
      previousLogs: [],
      logCommitted: false,
    }
  },
  computed: {
    remainingChars() {
      return this.maxLogLength - this.currentLogText.length;
    },
    logsDisabled() {
      return this.newReport || this.postGame;
    },
    emptyLog() {
      return this.currentLogText.length === 0;
    },
    finalCommit() {
      return this.unlockedReports.length === 4;
    },
    isAce() {
      return this.latestCardFormatted.includes('A');
    },
    buttonText() {
      let text;
      if (this.postGame) {
        text = 'LOCKDOWN Terminated';
      } else if (this.finalCommit) {
        text = 'Commit and terminate LOCKDOWN';
      } else {
        text = 'Commit and hibernate';
      }
      return text;
    },
    ...mapState({
      allLogs: state => state.logs.allLogs,
      maxLogLength: state => state.logs.maxLength,
      currentDay: state => state.calendar.currentDay,
      newReport: state => state.reports.newReport,
      postGame: state => state.gameSettings.postGame,
    }),
    ...mapGetters([
      'latestCardFormatted',
      'getSleepPrompt',
      'getDreamPrompt',
      'unlockedReports',
    ]),
  },
  methods: {
    commitLogHandler() {
      this.commitLog({
        card: this.latestCardFormatted,
        log: this.currentLogText,
      });
      if (this.finalCommit) {
        this.setPostGame();
      }
      this.saveState();
      this.currentLogText = '';
      this.logCommitted = true;
      if (this.finalCommit) {
        this.$router.push('/outro');
      } else {
        this.$router.push('/transition');
      }
    },
    ...mapMutations([
      'commitLog',
      'incrementDay',
      'saveState',
      'setPostGame',
    ]),
  },
  activated() {
    this.previousLogs = this.allLogs.map((log) => {
      var obj = Object.assign({}, log);
      obj.shouldDisplay = true;
      return obj;
    });

    this.logCommitted = false;

    if (this.newReport) {
      setTimeout(() => {
        this.showReport = true;
      }, 500);
    } else {
      this.showReport = false;
    }
  },
  beforeRouteLeave (to, from, next) {
    // prevent back button re-transition
    if (to.name === 'transition' && !this.logCommitted) {
      next(false);
    } else {
      next();
    }
  }
}
</script>

<style lang="css" scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}

button {
  margin: auto 0 auto auto;
  min-width: 200px;
  height: 33px;
}

.button-final {
  height: 50px;
  min-width: 180px;
}

.below-textarea {
  display: flex;
}

.latest-card:hover + .hidden-prompt {
  opacity: 1;
}

.hidden-prompt {
  opacity: 0;
  transition: opacity 0.3s;
  margin: auto 40px auto 20px;
  font-size: 13px;
}

.card-container {
  border: 1px solid var(--primary-color);
  height: 49px;
  min-width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  margin: 5px 0;
}

.card-container:hover {
  cursor: pointer;
}

.new-report {
  height: 155px;
  opacity: 1;
  pointer-events: all;
  border: 1px solid var(--primary-color);
  padding: 0 20px 25px 20px;
  border-radius: 5px;
  margin-top: 20px;
}

hr {
  margin-top: 10px;
}

.ace {
  background: var(--primary-color);
  color: var(--secondary-color);
}

.slide-fade-enter-active {
  transition: height 0.5s, opacity 0.5s 0.5s, margin-top 0s;
}
.slide-fade-leave-active {
  transition: opacity 0s, height 0s, margin-top 0s;
}
.slide-fade-enter, .slide-fade-leave-to {
  height: 0;
  opacity: 0;
  pointer-events: none;
  margin-top: 0px;
}
</style>
